<div class="mb-4 text-2xl font-bold">Invoice Library</div>

<aux-table-panel>
  <div class="p-[15px]">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        @if (!isJEConfigSetToAttribute()) {
          <div class="ml-7">
            <aux-checkbox
              class="mb-3 mt-3 text-sm"
              [disabled]="editMode()"
              (customChange)="checkRequireCostBreakdown($event)"
              [checked]="showRequireCostBreakdown()"
            >
              Require Cost Breakdown
            </aux-checkbox>
          </div>
        }

        <div class="ml-7">
          <aux-checkbox
            class="mb-3 mt-3 text-sm"
            [disabled]="editMode()"
            (customChange)="checkRequireAccrualPeriod($event)"
            [checked]="showRequireAccrualPeriod()"
          >
            Require Posting Period
          </aux-checkbox>
        </div>
        @if (showUnpaidInvoiceCheckbox()) {
          <div class="ml-7">
            <aux-checkbox
              class="mb-3 mt-3 text-sm"
              [disabled]="editMode()"
              (customChange)="checkUnpaidInvoices($event)"
              [checked]="showUnpaidInvoices()"
              data-pendo-id="unpaid-invoices-filter"
            >
              Unpaid Invoices
            </aux-checkbox>
          </div>
        }
        @if (!isJEConfigSetToAttribute()) {
          <div class="ml-7">
            <aux-checkbox
              class="mb-3 mt-3 text-sm"
              [disabled]="editMode()"
              (customChange)="checkInvalidCostCategorization($event)"
              [checked]="showInvalidCostCategorization()"
            >
              Invalid Cost Categorization
            </aux-checkbox>
          </div>
        }
      </div>

      <div class="grid grid-flow-col gap-x-1.5">
        <aux-invoices-sync-buttons />

        <aux-export-excel-button
          [clickFN]="onExportInvoices.bind(this)"
          [spinnerSize]="7"
          pendoTag="invoices-excel-export-button"
        />

        <aux-button
          classList="pl-3"
          variant="primary"
          label="Add New"
          [auxTooltip]="invoiceCtx.invoiceAddActionTooltip()"
          [onClick]="this.onNewInvoice.bind(this)"
          [disabled]="invoiceCtx.disabledAddInvoiceUI() || editMode()"
          icon="Plus"
        />
      </div>
    </div>

    <aux-invoice-filters class="mt-2" [form]="invoiceService.filtersForm" [editMode]="editMode()">
      <div bulkEditBlock class="flex h-[52.5px] flex-wrap items-end">
        @if (editMode()) {
          <aux-button
            variant="secondary"
            label="Bulk Edit"
            classList="mr-4"
            [auxTooltip]="invoiceCtx.invoiceLockTooltip()"
            [disabled]="
              savingChanges() ||
              isInvoiceFinalized() ||
              iCloseMonthsProcessing() ||
              !selectedRows().length
            "
            icon="Pencil"
            [spinnerSize]="7"
            [onClick]="onBulkApplyButtonClick"
          />
          <aux-button
            variant="negative"
            label="Delete"
            classList="mr-4"
            icon="Trash"
            [auxTooltip]="deleteButtonTooltip()"
            [disabled]="
              savingChanges() ||
              isInvoiceFinalized() ||
              iCloseMonthsProcessing() ||
              !selectedRows().length ||
              !permissions().hasDeleteInvoice
            "
            [onClick]="removeInvoices"
            [spinnerSize]="7"
          />
        }
      </div>

      <div togglesBlock class="flex h-[52.5px] flex-wrap items-end">
        @if (vendorCurrencyEnabled() && (!vendorHasOneCurrency || !isVendorCurrenciesUSD)) {
          <div class="mb-[2px]">
            <aux-toggle-budget-currency
              [value]="isVendorCurrency()"
              (nameSelectedCurrency)="selectedBudgetCurrencyType.set($event)"
            />
          </div>
        }
      </div>

      <div saveBlock class="ml-auto flex items-end justify-between">
        @if (editMode()) {
          <div class="grid grid-flow-col gap-x-1.5">
            <aux-button
              variant="secondary"
              label="Cancel"
              icon="X"
              [onClick]="onCancel"
              [disabled]="savingChanges()"
            />
            <aux-button
              variant="success"
              label="Save"
              icon="Check"
              [disabled]="!hasChanges()"
              [onClick]="onSave"
              [spinnerSize]="7"
            />
          </div>
        }

        @if (!editMode()) {
          <aux-button
            variant="secondary"
            label="Edit"
            icon="Pencil"
            [auxTooltip]="editButtonTooltip()"
            [disabled]="
              isInvoiceFinalized() || iCloseMonthsProcessing() || !permissions().hasEditInvoice
            "
            [onClick]="enableEditMode"
          />
        }
      </div>
    </aux-invoice-filters>
  </div>

  @if (loading()) {
    <aux-table-skeleton />
  } @else {
    <aux-pagination-grid
      [idTable]="'invoiceLibraryGrid'"
      [gridOptions]="gridOptions()"
      [dataSource]="datasource"
      [masterDetail]="isJEConfigSetToAttribute()"
      [detailCellRenderer]="detailCellRenderer"
      [embedFullWidthRows]="isJEConfigSetToAttribute()"
      [isAgThemeFlat]="true"
      [filterForm]="invoiceService.filtersForm"
      [serverSideFilters]="serverSideFilters"
      [filterValues$]="filterValues$"
      [sortModel$]="sortModel$"
      [hidePinnedRow]="true"
      [enableFillHandle]="editMode()"
      [loading]="loading()"
      [isRowMaster]="isRowMaster"
      [paginationKey]="paginationKey"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="firstDataRendered($event)"
      (paginationChange)="paginationChange()"
      (cellValueChanged)="cellValueChanged($event)"
      (rowSelected)="rowSelected($event)"
      (selectionChanged)="selectionChanged($event)"
      (sortChanged)="sortChanged$.next(null)"
      (modelUpdated)="modelUpdated($event)"
    />
  }

  @if (showExportFull()) {
    <aux-export-full-dataset-button
      class="flex justify-end"
      [datasource]="datasource"
      [totalRows]="totalRows()"
      [processEvent]="processExportEvent"
    />
  }
</aux-table-panel>
